(function(){
  var star='<svg viewBox="0 0 24 24"><path d="M12 2l3 6.9 7.5.6-5.7 4.9 1.8 7.3L12 17.8 5.1 21.7l1.8-7.3L1.2 9.5l7.5-.6z"/></svg>';

  function money(c){ return '€' + (Math.round(c)/100).toFixed(2).replace('.', ','); }

  /* ---- countdown ---- */
  var td=document.getElementById('t-d');
  if(td){
    var end=Date.now()+(7*3600+52*60)*1000;
    var pad=function(x){return(x<10?'0':'')+x;};
    (function tick(){var d=Math.max(0,end-Date.now());
      td.textContent=pad(Math.floor(d/86400000));
      document.getElementById('t-h').textContent=pad(Math.floor(d%86400000/3600000));
      document.getElementById('t-m').textContent=pad(Math.floor(d%3600000/60000));
      document.getElementById('t-s').textContent=pad(Math.floor(d%60000/1000));
      setTimeout(tick,1000);})();
  }

  /* ---- mobile menu ---- */
  var mb=document.querySelector('.menu-btn');
  if(mb){mb.addEventListener('click',function(){var n=document.querySelector('.nav');if(!n)return;var open=n.classList.toggle('nav--open');});}

  /* ---- cart drawer ---- */
  var drawer=document.getElementById('cartDrawer'), ov=document.getElementById('drawerOv');
  function openDrawer(){ if(!drawer)return; drawer.classList.add('open'); ov.classList.add('show'); document.body.style.overflow='hidden'; }
  function closeDrawer(){ if(!drawer)return; drawer.classList.remove('open'); ov.classList.remove('show'); document.body.style.overflow=''; }
  var cdClose=document.getElementById('cd-close'); if(cdClose)cdClose.addEventListener('click',closeDrawer);
  if(ov)ov.addEventListener('click',closeDrawer);
  var cdItemsEl=document.getElementById('cd-items');
  if(cdItemsEl)cdItemsEl.addEventListener('click',function(e){
    var del=e.target.closest('.cd-del'); if(!del)return;
    var line=parseInt(del.dataset.line,10); del.disabled=true;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:0})}).then(function(r){return r.json();}).then(renderDrawer).catch(function(){});
  });
  var cartLink=document.getElementById('cartLink');
  if(cartLink)cartLink.addEventListener('click',function(e){ if(drawer){ e.preventDefault(); refreshCart(); openDrawer(); } });

  function renderDrawer(cart){
    document.querySelectorAll('.cart-count').forEach(function(el){el.textContent=cart.item_count;});
    var cnt=document.getElementById('cd-count'); if(cnt)cnt.textContent=cart.item_count;
    var items=document.getElementById('cd-items'), empty=document.getElementById('cd-empty'), foot=document.getElementById('cd-foot');
    if(!items)return;
    if(cart.item_count===0){ items.innerHTML=''; if(empty)empty.style.display='block'; if(foot)foot.style.display='none'; }
    else {
      if(empty)empty.style.display='none'; if(foot)foot.style.display='block';
      items.innerHTML=cart.items.map(function(it,ix){
        var priceHtml = it.total_discount>0
          ? '<s>'+money(it.original_line_price)+'</s> <b>'+money(it.final_line_price)+'</b>'
          : '<b>'+money(it.final_line_price)+'</b>';
        var freeTag = it.total_discount>0 ? '<span class="cd-freetag">FREE PAIRS UNLOCKED</span>' : '';
        var trash='<button type="button" class="cd-del" data-line="'+(ix+1)+'" aria-label="Remove" style="position:absolute;top:10px;right:0;width:26px;height:26px;color:#b0b0b0;display:flex;align-items:center;justify-content:center"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 11v6M14 11v6"/></svg></button>';
        return '<div class="cd-item" style="position:relative;padding-right:26px">'+trash+'<img src="'+(it.image?it.image:'')+'" alt=""><div class="cd-item__b"><div class="cd-item__t">'+it.product_title+'</div>'+freeTag+'<div class="cd-item__v">'+(it.variant_title||'')+'</div><div class="cd-item__q">Qty: '+it.quantity+'</div></div><div class="cd-item__p">'+priceHtml+'</div></div>';
      }).join('');
    }
    var sav=document.getElementById('cd-savings'); if(sav)sav.textContent='−'+money(cart.total_discount||0);
    var tot=document.getElementById('cd-total'); if(tot)tot.textContent=money(cart.total_price);
    // progress toward 7
    var q=cart.item_count, fill=document.getElementById('cd-fill'), msg=document.getElementById('cd-msg');
    if(fill)fill.style.width=Math.min(100,(q/7)*100)+'%';
    if(msg){
      if(q>=7)msg.innerHTML='🎉 You unlocked <b>4 FREE pairs</b>!';
      else if(q>=3)msg.innerHTML='🎉 <b>Free pairs unlocked</b> — add more to save more';
      else msg.innerHTML='Add <b>'+(3-q)+' more pair'+((3-q)===1?'':'s')+'</b> to unlock <b>free pairs</b>';
    }
  }
  function refreshCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(renderDrawer).catch(function(){}); }
  refreshCart();

  /* ---- product page ---- */
  var P=window.KAIDO_PRODUCT;
  if(P){
    var mainImg=document.getElementById('g-main'), track=document.getElementById('thumbs'), idx=0;
    var imgs=P.images||[];
    if(mainImg&&imgs.length){
      mainImg.src=imgs[0];mainImg.alt=P.title;
      imgs.forEach(function(src,i){var t=document.createElement('div');t.className='thumb'+(i===0?' is-active':'');t.innerHTML='<img src="'+src+'" alt="View '+(i+1)+'">';t.addEventListener('click',function(){setImg(i);});track.appendChild(t);});
    }
    function setImg(i){idx=(i+imgs.length)%imgs.length;mainImg.src=imgs[idx];[].forEach.call(track.children,function(c,ci){c.classList.toggle('is-active',ci===idx);});var a=track.children[idx];if(a)a.scrollIntoView({inline:'nearest',block:'nearest'});}
    var gp=document.getElementById('g-prev'),gn=document.getElementById('g-next');
    if(gp)gp.addEventListener('click',function(){setImg(idx-1);});
    if(gn)gn.addEventListener('click',function(){setImg(idx+1);});

    var selColor=(P.colors[0]||{}).name, selSize=(P.sizes[0]||null);
    var swWrap=document.getElementById('swatches'), szWrap=document.getElementById('sizes');
    var colorName=document.getElementById('color-name'), sizeName=document.getElementById('size-name');
    if(colorName&&selColor)colorName.textContent='— '+selColor;
    if(sizeName&&selSize)sizeName.textContent='— '+selSize;

    if(swWrap)P.colors.forEach(function(c,i){
      var d=document.createElement('span');d.className='swatch'+(i===0?' is-active':'');d.style.background=c.hex;d.dataset.color=c.name;
      if(/^#(ee|ff)/i.test(c.hex))d.style.border='1px solid #ccc';d.title=c.name;
      d.addEventListener('click',function(){selColor=c.name;[].forEach.call(swWrap.children,function(x){x.classList.toggle('is-active',x.dataset.color===c.name);});if(colorName)colorName.textContent='— '+c.name;if(c.image!=null)setImg(c.image);updateVariant();});
      swWrap.appendChild(d);
    });
    if(szWrap)(P.sizes||[]).forEach(function(s,i){
      var b=document.createElement('button');b.type='button';b.className='size'+(i===0?' is-active':'');b.textContent=s;
      b.addEventListener('click',function(){selSize=s;[].forEach.call(szWrap.children,function(x){x.classList.remove('is-active');});b.classList.add('is-active');if(sizeName)sizeName.textContent='— '+s;updateVariant();});
      szWrap.appendChild(b);
    });

    var atc=document.getElementById('atc'), idField=document.getElementById('variant-id');
    function findVariant(){return P.variants.filter(function(v){return (!P.hasColor||v.color===selColor)&&(!P.hasSize||v.size===selSize);})[0];}
    function updateVariant(){var v=findVariant();
      if(!v){atc.disabled=true;atc.textContent='Unavailable';return;}
      idField.value=v.id;atc.disabled=!v.available;atc.textContent=v.available?'Add to Cart':'Sold Out';
    }
    updateVariant();

    /* pack selector */
    var packs=document.getElementById('packs'), selQty=7;
    if(packs){
      var first=packs.querySelector('.pack.is-active'); if(first)selQty=parseInt(first.dataset.qty,10)||1;
      [].forEach.call(packs.querySelectorAll('.pack'),function(lb){
        lb.addEventListener('click',function(e){e.preventDefault();[].forEach.call(packs.querySelectorAll('.pack'),function(x){x.classList.remove('is-active');});lb.classList.add('is-active');selQty=parseInt(lb.dataset.qty,10)||1;});
      });
    }

    var form=document.getElementById('product-form');
    if(form)form.addEventListener('submit',function(e){e.preventDefault();var v=findVariant();if(!v||!v.available)return;
      atc.disabled=true;var o=atc.textContent;atc.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:v.id,quantity:selQty})})
        .then(function(r){return r.json();}).then(function(){return refreshCart();}).then(function(){atc.textContent=o;atc.disabled=false;openDrawer();})
        .catch(function(){atc.textContent=o;atc.disabled=false;});
    });

    var acc=document.getElementById('acc');
    if(acc){acc.addEventListener('click',function(e){var h=e.target.closest('.acc__head');if(!h)return;var item=h.parentElement,body=h.nextElementSibling;var open=item.classList.toggle('is-open');body.style.maxHeight=open?body.firstElementChild.scrollHeight+'px':0;});
      var fo=acc.querySelector('.acc__item.is-open .acc__body');if(fo)fo.style.maxHeight=fo.firstElementChild.scrollHeight+'px';}

    var sticky=document.getElementById('stickyAtc');
    if(sticky){window.addEventListener('scroll',function(){if(window.innerWidth>749){sticky.classList.remove('show');return;}sticky.classList.toggle('show',window.scrollY>640);});
      var sb=sticky.querySelector('.sticky-atc__btn');if(sb)sb.addEventListener('click',function(){atc.click();});}
  }
})();
